import React, { useState, useEffect } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { MdDownload } from 'react-icons/md';
import logo from '../assets/HYVE_LogoMaster_2_1.png';

export default function SharedHeader() {
    const [scrolled, setScrolled] = useState(false);
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });

    // Header scroll effect
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            {/* Scroll Progress Bar */}
            <motion.div
                className="fixed top-0 left-0 right-0 h-1 bg-[#7C3AED] z-[100] origin-left"
                style={{ scaleX }}
            />

            <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-lg border-b ${scrolled ? 'bg-white/90 border-gray-200 shadow-sm' : 'bg-white/50 border-white/0'}`}>
                <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                    <a href="/" className="flex items-center gap-2 group cursor-pointer no-underline">
                        <motion.img
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5 }}
                            src={logo} alt="uHyve Logo" className="h-12 w-auto object-contain"
                        />
                        <motion.span
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            className="font-display text-2xl font-bold text-[#4C1D95] tracking-tight"
                        >
                            uHyve
                        </motion.span>
                    </a>
                    <nav className="hidden md:flex items-center justify-center flex-1 gap-8">
                        <a className="text-gray-600 hover:text-[#0B1120] text-[15px] font-medium transition-colors hover:underline" href="/#benefits">Why Uhyve</a>
                        <a className="text-gray-600 hover:text-[#0B1120] text-[15px] font-medium transition-colors hover:underline" href="/#features">Features</a>
                        <a className="text-gray-600 hover:text-[#0B1120] text-[15px] font-medium transition-colors hover:underline" href="/#pricing">Pricing</a>
                    </nav>
                    <div className="flex items-center gap-4">
                        <motion.a
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://apps.apple.com/ca/app/uhyve/id6751551335" target="_blank" rel="noopener noreferrer" className="bg-[#7C3AED] hover:bg-[#6D28D9] text-white px-6 py-2.5 rounded-full text-[14px] font-bold flex items-center gap-2 transition-all shadow-lg hover:no-underline"
                        >
                            <MdDownload className="text-xl" />
                            <span>Get App</span>
                        </motion.a>
                    </div>
                </div>
            </header>
        </>
    );
}
